<style lang="less">
.dcBtnArea {
  width: 4.8rem;
  margin: 0 auto;
  padding: 0.2rem 0 0.4rem;
  .k-button {
    height: .88rem;
    line-height: .88rem;
    background-image: linear-gradient(270deg, #c7a862 0%, #f8efbc 100%);
    box-shadow: inset 0 0.03rem 0.06rem 0 rgba(248, 247, 242, 0.5);
    border-radius: 0.36rem;
    font-size: .34rem;
  }
}
</style>
<template>
  <div v-if="takeUid > 0" class="dcBtnArea">
    <router-link  v-if="myUid === takeUid" href="/award2020/dianjin/list"><k-button block>我的软件</k-button></router-link>
    <router-link v-else-if="inDCService" to="/dc"><k-button block>前往赠送</k-button></router-link>
  </div>
  <div v-else class="dcBtnArea">
    <k-button v-if="isGiver" block @click="share()">分享赠送</k-button>
    <router-link  v-else-if="myUid > 0" to="/dc"><k-button block>立即前往</k-button></router-link>
    <k-button v-else block @click="goRegister()">注册领取</k-button>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('laxin', [
      'inDCService'
    ]),
    ...mapGetters('laxin/dc', [
      'myUid',
      'giveUid',
      'takeUid',
      'giveUser',
      'takeUser',
      'isGiver'
    ])
  },
  methods: {
    ...mapActions('account', ['goRegister']),
    ...mapActions('laxin', ['share'])
  }
}
</script>
